import { VideoAreaClip } from './types';

export const heroClips: VideoAreaClip[] = [
  {
    duration: 2000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-24-285.webp',
  },
  {
    duration: 5000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-22-401.webp',
  },
  {
    duration: 5000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-23-922.webp',
  },
  {
    duration: 5000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-24-636.webp',
  },
  {
    duration: 5000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-24-984.webp',
  },
  {
    duration: 3000,
    type: 'image',
    url: 'https://rizosrealty.blob.core.windows.net/site-content/backgrounds/hero/viber_image_2025-10-31_17-28-24-285.webp',
  },
];
